import "./WellbeingRiskRadar.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import EightStressRiskAreas from "./sections/EightStressRiskAreas";
import PricingPackages from "./sections/PricingPackages";
import FaqsAccordion from "./sections/FaqsAccordion";
import CallToActionSection from "./sections/CallToActionSection";
import MultiColumnFooter from "./sections/MultiColumnFooter";
import Footer from "@/reusable_sections/Footer";
export default function WellbeingRiskRadarPage() {
  return <div>
      <Header />
      <HeroSection />
      <EightStressRiskAreas />
      <PricingPackages />
      <FaqsAccordion />
      <CallToActionSection />
      <MultiColumnFooter />
      <Footer />
    </div>;
}